import { computed } from "vue"
import { jwtDecode, JwtPayload } from "jwt-decode"
import { createGlobalState, useStorage } from "@vueuse/core"
import AuthApi, { InvalidUserConfigError } from "@/api/auth.ts"
import { useRouter } from "vue-router"

export type User = {
	id: string
	firstName: string
	lastName: string
	role: string
	shopId: string
	shopName: string
	shopCashReserve: number
	shopCashCoinMaximum: number
}

export const dummyUser: User = {
	id: "12345678-5678-1234-5678-123456781234",
	firstName: "John",
	lastName: "Doe",
	role: "Kassierer",
	shopId: "12345678-5678-1234-5678-123456781234",
	shopName: "42",
	shopCashReserve: 150_00,
	shopCashCoinMaximum: 120_00,
}

type TokenPayload = JwtPayload & {
	user: {
		id: string,
		username: string
		firstname: string
		lastname: string
		role: string
	}
	shop: {
		id: string
		name: string
		cash_reserve: number

	}
}


function getUserFromToken(token: string): User {
	try {
		const { user, shop } = jwtDecode<TokenPayload>(token)

		return {
			id: user.id,
			firstName: user.firstname,
			lastName: user.lastname,
			role: user.role,
			shopId: shop.id,
			shopName: shop.name,
			shopCashReserve: shop.cash_reserve,
			shopCashCoinMaximum: 12_000, // TODO: Will be provided by API eventually
		}
	} catch (err) {
		throw new InvalidUserConfigError(`Der API Token ist nicht gültig: ${err}`)
	}
}

export const useAuth = createGlobalState(() => {
	const token = useStorage<string | null>("frantax-kb-token", null, window.localStorage)

	const user = computed<User | null>(() => {
		if (!token.value) {
			return null
		}

		return getUserFromToken(token.value)
	})

	async function login(username: string, password: string): Promise<void> {
		token.value = await AuthApi.login(username, password)
	}

	async function logout() {
		if (!token.value) {
			return
		}

		await AuthApi.logout(token.value)
		token.value = null
	}

	async function redirectToLogin() {
		const router = useRouter()
		return router.push("/login")
	}

	return {
		token,
		user,
		login,
		logout,
		redirectToLogin,
	}
})
